import "./index.scss";

import CopyToClipboardSVG from "assets/img/svg/copy";
import { CSSProperties, useState } from "react";
import { useTranslation } from "react-i18next";

interface ICopyToClipboard {
    children: string;
    style?: React.CSSProperties;
    className?: string;
    color?: string;
    label?: string;
    icon?: boolean;
    fullWidth?: boolean;
}

const CopyToClipboard = ({
    children,
    style,
    className,
    color,
    label,
    icon = true,
    fullWidth = false,
}: ICopyToClipboard) => {
    const [t] = useTranslation();
    const [activePopup, setActivePopup] = useState<HTMLDivElement | null>(null);

    const copyText = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
        closeActivePopup();
        navigator.clipboard.writeText(children).then(() => showCopiedPopup(e.clientX, e.clientY));
    };

    const showCopiedPopup = (x: number, y: number) => {
        const popup = createPopup(t("Settings.TextCopied"));
        positionPopupAboveCursor(popup, x, y);
        document.body.appendChild(popup);
        popup.offsetWidth; // render the animation
        popup.className += " opacity-1";
        setActivePopup(popup);
        setTimeout(() => {
            fadeOutAndRemove(popup);
        }, 800);
    };

    /**
     * Manipulate DOM to create the popup place it above cursor upside all HTML elements.
     */
    const createPopup = (text: string): HTMLDivElement => {
        const popup = document.createElement("div");
        popup.textContent = text;
        popup.classList.add("copied-popup");
        return popup;
    };

    /**
     * Remove popup
     */
    const fadeOutAndRemove = (element: HTMLElement) => {
        element.classList.remove("opacity-1");
        setTimeout(() => {
            element.remove();
        }, 200);
    };

    /**
     * Position the popup above cursor
     */
    const positionPopupAboveCursor = (popup: HTMLDivElement, x: number, y: number) => {
        const offsetX = 15;
        const offsetY = -10;
        popup.style.left = `${x + offsetX}px`;
        popup.style.top = `${y + offsetY - popup.offsetHeight}px`;
    };

    /**
     * If a popup is ever active, remove it (avoid multiple popup if quick click between elements)
     */
    const closeActivePopup = () => {
        if (activePopup) {
            const popup = document.querySelector(".copied-popup");
            popup?.remove();
            setActivePopup(null);
        }
    };

    return (
        <div className="copy-to-clipboard" onClick={copyText} style={fullWidth ? { width: "100%" } : {}}>
            <span className={className} style={{ ...style, color }}>
                {label && `${label} `}
                <span className="hover-underline">{children}</span>
            </span>
            {icon && <CopyToClipboardSVG height="16" width="16" color={color} />}
        </div>
    );
};

export default CopyToClipboard;
